/**
 * Libellés harmonisés — espace Infirmerie (cohérence réception / admin personnel).
 */

const VISIT_HISTORY = {
  PANEL_TITLE: 'Journal des passages à l’accueil',
  PANEL_SUBTITLE:
    'Passages filière infirmerie · période, société, recherche texte et export CSV.',

  PAGE_BADGE: 'Historique',
  PAGE_TITLE: 'Historique des passages',
  PAGE_SUBTITLE:
    'Journal chronologique des passages enregistrés à l’accueil, filière infirmerie par défaut.',

  NAV_LABEL: 'Historique des passages',
  NAV_HINT: 'Journal chronologique des passages accueil · filtres période et société',

  CARD_TITLE: 'Historique des passages',
  CARD_DESC: 'Journal des passages enregistrés à l’accueil (site, société, filière, consultation)'
};

export const NURSE_COPY = {
  /** Aligné autres espaces FUNTOA SMIE */
  TAGLINE_INSTITUTIONAL: 'Sécurité et santé : main dans la main vers le succès',

  LAYOUT: {
    NAVBAR_BRAND: 'Infirmerie FUNTOA SMIE',
    SIDE_MENU_SECTION: 'Parcours infirmerie',
    NO_SITE_ASSIGNED: 'Aucun site affecté au profil',
    SITE_SELECT_ARIA: 'Site de travail',
    ACCOUNT_FALLBACK: 'Compte',
    ACCOUNT_MENU_ARIA: 'Menu du compte infirmerie',
    CHANGE_SITE_CHIP_TITLE: 'Changer le site infirmerie',
    CHANGE_SITE_MENU: 'Changer de site',
    SITE_ACTIVE_TOAST: 'Site infirmerie actif : {name}',
    SITE_GATE_TITLE: 'Choisir votre site de travail',
    SITE_GATE_DESC:
      'Sélectionnez le site infirmerie où vous travaillez maintenant. La file, les passages et les consultations infirmières utiliseront ce site pour cette session.',
    SITES_LOADING: 'Chargement des sites…',
    SITE_CARD_META_FALLBACK: 'Site infirmerie',
    SITE_CARD_CTA: 'Commencer',
    SIDEBAR_NAV_ARIA: 'Navigation principale',
    SIDEBAR_TOGGLE_COLLAPSED: 'Déplier le menu infirmerie',
    SIDEBAR_TOGGLE_EXPANDED: 'Replier le menu infirmerie',
    SIDEBAR_TOGGLE_COLLAPSED_SHORT: 'Déplier',
    SIDEBAR_TOGGLE_EXPANDED_SHORT: 'Replier',
    HEADER_CLOCK_TITLE: 'Heure référencée sur le serveur, resynchronisée toutes les 2 min',
    LOGOUT: 'Déconnexion',
    SITE_CHIP_LABEL: 'Site'
  },

  NAV: {
    dashboard: {
      label: 'Tableau de bord',
      hint: 'Poste infirmerie, priorités et accès rapides'
    },
    accueil: {
      label: 'Accueil adhérent',
      hint: 'Poste d’accueil infirmerie · recherche et passage NURSING'
    },
    file: {
      label: 'File infirmerie',
      hint: 'Passages en cours et terminés du site'
    },
    historique: {
      label: VISIT_HISTORY.NAV_LABEL,
      hint: VISIT_HISTORY.NAV_HINT
    },
    pharmacie: {
      label: 'Pharmacie locale',
      hint: 'Stock et délivrances du site'
    },
    aide: {
      label: 'Aide infirmerie',
      hint: 'Parcours filière NURSING et rubriques du passage'
    }
  },

  VISIT_HISTORY,

  TOASTS: {
    CONSULT_SAVED: 'Consultation enregistrée.'
  },

  WORKSPACE: {
    EXAM_TITLE: 'Examen médical',
    EXAM_DESC:
      'Même disposition que le médecin : dossier à gauche, ordonnance à droite. Enregistrement combiné possible depuis le panneau ordonnance.',
    EXAM_COL_CLINICAL: 'Examen clinique',
    EXAM_COL_RX: 'Ordonnance',
    NEW_TITLE: 'Nouvelle consultation · examen',
    NEW_DESC:
      'Créez le passage puis complétez la ou les rubriques utiles : soins & tests, constantes ou examen.',
    CLOSE_TITLE: 'Fin de prise en charge',
    CLOSE_HINT: 'Transférez vers le médecin ou clôturez la visite infirmerie.',
    CLOSE_ALREADY: 'Ce passage est déjà clôturé ou transféré — consultation en lecture seule.',
    CLOSE_CHECK_DISEASE_OK: 'Diagnostic codé (code maladie) renseigné',
    CLOSE_CHECK_END: 'Après clôture, le passage quitte la file active.',
    CLOSE_DISEASE_LABEL: 'Diagnostic (codes maladie)',
    CLOSE_NOTE_LABEL: 'Note de clôture (optionnel)',
    CLOSE_NOTE_PLACEHOLDER: 'Observations de fin de prise en charge…',
    NAV_PREV: 'Précédent',
    NAV_PREV_SHORT: 'Préc.',
    NAV_NEXT: 'Suivant',
    NAV_NEXT_SHORT: 'Suiv.',
    PASSAGE_SECTIONS_HINT:
      'Constantes, soins & tests ou examen — une seule rubrique suffit selon la prise en charge.',
    PASSAGE_NAV_ARIA: 'Navigation du passage',
    FOOTER_ARIA: 'Navigation du passage et fin de prise en charge',
    FOOTER_TRANSFER: 'Transférer médecin',
    FOOTER_TRANSFER_SHORT: 'Transférer',
    FOOTER_CLOSE: 'Clôturer visite',
    FOOTER_CLOSE_SHORT: 'Clôturer'
  },

  DASHBOARD: {
    BADGE: 'Infirmerie',
    OPS_BADGE: 'Poste infirmerie',
    PAGE_TITLE: 'Tableau de bord',
    PAGE_SUBTITLE:
      'Accueil adhérent et file d’attente infirmerie sur le site courant — comme le poste d’accueil réception.',
    REFRESH: 'Actualiser',
    NO_SITE: 'Sélectionnez un site de travail pour afficher la file infirmerie.',

    OPS_TITLE: 'Poste infirmerie',
    OPS_SUBTITLE: 'Identifiez l’adhérent, enregistrez le passage NURSING et suivez la file en direct.',

    INTAKE: {
      EYEBROW: 'Identification',
      TITLE: 'Accueillir un adhérent',
      SUBTITLE: 'Matricule, nom, prénom ou téléphone — orientation infirmerie automatique.',
      SUBTITLE_SITE: 'identifiez le patient puis accueillez-le à l’infirmerie.',
      SEARCH_LABEL: 'Recherche patient',
      SEARCH_PLACEHOLDER: 'Matricule, nom, prénom ou téléphone…',
      SEARCH_BUTTON: 'Rechercher',
      SEARCHING: 'Recherche',
      SEARCH_MIN: 'Saisissez au moins 2 caractères (matricule, nom ou prénom).',
      SEARCH_EMPTY: 'Aucun résultat pour cette recherche',
      SEARCH_ERROR: 'Erreur de recherche',
      CLEAR_SEARCH: 'Effacer la recherche patient',
      HINT_SEARCH: 'La recherche se lance automatiquement. Sélectionnez un résultat pour afficher la fiche.',
      HINT_SELECTED: 'Patient identifié. Vérifiez la fiche puis accueillez-le à l’infirmerie.',
      SMIE_RESULTS: 'Adhérents SMIE',
      EXTERNAL_RESULTS: 'Membres externes',
      SELECT: 'Sélectionner',
      PATIENT_IDENTIFIED: 'Patient identifié',
      CHANGE_PATIENT: 'Changer',
      RECENT_EYEBROW: 'Dernières activités',
      RECENT_TITLE: '5 derniers passages',
      RECENT_LOADING: 'Chargement des derniers passages…',
      NO_RECENT: 'Aucun passage récent pour ce patient.',
      HISTORY_ERROR: 'Historique récent indisponible.',
      EXTERNAL_HISTORY: 'Historique automatique disponible pour les adhérents avec matricule.',
      NO_HISTORY: 'Historique indisponible sans matricule.',
      WELCOME_BUTTON: 'Accueillir à l’infirmerie',
      QUICK_ACTIONS_ARIA: 'Actions rapides',
      ADD_EXTERNAL: 'Membre externe',
      ADD_EXTERNAL_MENU: 'Ajouter un membre externe',
      EXTERNAL_MODAL_TITLE: 'Nouveau membre externe',
      EXTERNAL_CREATED: 'Membre externe créé.',
      EXTERNAL_ERROR: 'Création membre externe impossible.',
      NO_SITE: 'Sélectionnez d’abord votre site de travail dans la barre supérieure.',
      INVALID_SITE: 'Site invalide.',
      INTAKE_SUCCESS: 'Passage enregistré · patient ajouté à la file infirmerie.',
      INTAKE_ERROR: 'Enregistrement impossible.'
    },

    WAITING: {
      EYEBROW: 'File d’attente',
      TITLE: 'Patients orientés infirmerie',
      SUBTITLE: 'Passages NURSING actifs sur le site — en attente de prise en charge.',
      SUBTITLE_TODAY: 'Passages NURSING actifs du jour — orientés réception ou accueillis ici.',
      REFRESH: 'Actualiser',
      REFRESH_ARIA: 'Actualiser la file infirmerie',
      LOADING: 'Chargement de la file infirmerie…',
      EMPTY_TITLE: 'File vide pour ce site',
      EMPTY_DESC: 'Aucun patient en attente. Accueillez un adhérent ou attendez une orientation depuis la réception.',
      EMPTY_DESC_TODAY:
        'Aucun patient infirmerie aujourd’hui. Accueillez un adhérent à gauche ou consultez la file complète.',
      OLDER_ACTIVE_ONE: '1 passage en cours date d’un jour précédent.',
      OLDER_ACTIVE_MANY: '{n} passages en cours datent d’un jour précédent.',
      OLDER_ACTIVE_LINK: 'Ouvrir la file complète',
      SEE_ALL_FILE: 'Voir toute la file infirmerie →',
      LIST_ARIA: 'File d’attente infirmerie',
      COL_PATIENT: 'Patient',
      COL_STATUS: 'Statut',
      COL_ACTION: 'Action',
      ACTION_OPEN: 'Ouvrir'
    },

    QUEUE_TITLE: 'File infirmerie — priorités',
    QUEUE_SUBTITLE: 'Cliquez sur un indicateur pour ouvrir la file filtrée.',

    STAT_PENDING: 'À traiter',
    STAT_PENDING_HINT: 'Passages sans rubrique saisie encore',
    STAT_EXAM: 'En examen',
    STAT_EXAM_HINT: 'Examen médical en cours',
    STAT_CARE: 'En soins',
    STAT_CARE_HINT: 'Actes, tests ou constantes enregistrés',
    STAT_DONE: 'Terminés',
    STAT_DONE_HINT: 'Clôturés ou transférés',

    QUICK_TITLE: 'Autres accès',
    QUICK_SUBTITLE: 'Modules complémentaires du poste infirmier.',

    QUICK_ACCUEIL: {
      TITLE: 'Accueil adhérent',
      HINT: 'Page dédiée poste d’accueil infirmerie'
    },
    QUICK_FILE: {
      TITLE: 'File infirmerie',
      HINT: 'Tous les passages du site · filtres par statut'
    },
    QUICK_HISTORY: {
      TITLE: 'Historique des passages',
      HINT: 'Journal accueil · filière infirmerie'
    },
    QUICK_PHARMACY: {
      TITLE: 'Pharmacie locale',
      HINT: 'Dispensation minimale sur le site'
    },
    QUICK_GUIDE: {
      TITLE: 'Aide infirmerie',
      HINT: 'Parcours filière et rubriques du passage'
    }
  },

  ACCUEIL: {
    BADGE: 'Accueil adhérent',
    PAGE_TITLE: 'Accueil adhérent — infirmerie',
    PAGE_SUBTITLE:
      'Même poste d’accueil que le tableau de bord : recherche patient, passage NURSING et file du jour.',
    REFRESH: 'Actualiser',
    SECTION_ARIA: 'Poste accueil infirmerie',
    SECTION_BADGE: 'Poste d’accueil',
    SECTION_TITLE: 'Accueil du jour',
    SECTION_DESC: 'Identifiez l’adhérent et enregistrez son passage infirmerie.',
    SECTION_DESC_SITE: 'identifiez l’adhérent et enregistrez son passage infirmerie.'
  },

  GUIDE: {
    BADGE: 'Aide',
    PAGE_TITLE: 'Aide infirmerie FUNTOA SMIE',
    PAGE_SUBTITLE:
      'Accueil adhérent → file → passage (soins, injections, tests, vaccins, planning familial, constantes ou examen) → clôture ou transfert médecin.',
    INTRO:
      'Chaque passage infirmerie est lié au site et, pour les adhérents, à la fiche membre. Une seule rubrique suffit selon la prise en charge.',
    STEPS: [
      {
        title: '1. Accueil & file',
        text: 'Identifiez l’adhérent au poste d’accueil ou ouvrez la file du site. Le passage s’ajoute tout de suite à la file infirmerie.'
      },
      {
        title: '2. Actes du passage',
        text: 'Cochez les soins, injections, tests, vaccins ou actes de planning familial réalisés. Chaque onglet s’enregistre séparément.'
      },
      {
        title: '3. Constantes & examen',
        text: 'Saisissez les constantes si besoin, puis l’examen infirmier. Vous n’êtes pas obligé de tout remplir.'
      },
      {
        title: '4. Fin de prise en charge',
        text: 'Clôturez la visite ou transférez vers le médecin. La facture se constitue à la clôture du passage.'
      }
    ]
  },

  ACTS_PANEL: {
    TITLE: 'Actes infirmerie',
    DESC: 'Cochez les actes réalisés par onglet · soins, injections, planning familial, tests et vaccins.',
    TABS_ARIA: 'Soins, injections, planning familial, tests, vaccins ou historique',
    CARE_TAB: 'Soins',
    INJECTION_TAB: 'Injections',
    FAMILY_PLANNING_TAB: 'Planning familial',
    TESTS_TAB: 'Tests',
    VACCINES_TAB: 'Vaccins',
    HISTORY_TAB: 'Historique',
    HISTORY_EMPTY: 'Aucun événement pour ce passage.'
  },

  TEST_CHECKLIST: {
    INTRO: 'Cochez les tests effectués et saisissez le résultat sur chaque carte.',
    LOADING: 'Chargement du catalogue tests…',
    EMPTY_CATALOG: 'Catalogue tests vide — configuration par la direction médicale.',
    EMPTY_FILTER: 'Aucun test pour ce filtre.',
    STAT_TOTAL: 'Tests',
    STAT_CHECKED: 'Cochés',
    STAT_SAVED: 'Enregistrés',
    STAT_PENDING: 'À enregistrer',
    FILTER_VIEW_ARIA: 'Filtrer l’affichage',
    FILTER_ALL: 'Tous',
    FILTER_CHECKED: 'Cochés',
    FILTER_PENDING: 'À enregistrer',
    FILTER_ALL_TYPES: 'Toutes catégories',
    SELECT_ALL_VISIBLE: 'Tout cocher (vue)',
    CLEAR_NEW: 'Annuler les nouveaux',
    RECORDED_BADGE: 'OK',
    PENDING_BADGE: 'À saisir',
    UNIT_LABEL: 'Unité',
    RESULT_LABEL: 'Résultat',
    RESULT_PLACEHOLDER: 'Ex. 5,2 ou Négatif',
    RESULT_HINT: 'Attendu :',
    GLOBAL_NOTE_LABEL: 'Note commune (optionnel)',
    GLOBAL_NOTE_PLACEHOLDER: 'Note pour tous les nouveaux tests…',
    SAVE_BUTTON: 'Enregistrer ({n}) test(s)',
    SAVE_BUTTON_NONE: 'Enregistrer les tests',
    NOTHING_NEW: 'Aucun nouveau test à enregistrer.',
    MISSING_RESULTS: '{n} test(s) sans résultat — complétez les champs sur les cartes orange.',
    SAVED_ONE: 'Test enregistré.',
    SAVED_MANY: '{n} tests enregistrés.',
    SAVE_ERROR: 'Enregistrement des tests impossible.',
    MANUAL_TITLE: 'Tests hors catalogue'
  },

  CARE_CHECKLIST: {
    INTRO: 'Cliquez sur une carte pour cocher l’acte réalisé.',
    LOADING: 'Chargement du catalogue…',
    EMPTY_CATALOG: 'Catalogue vide — configuration par la direction médicale.',
    EMPTY_FILTER: 'Aucun acte pour ce filtre.',
    STAT_TOTAL: 'Actes',
    STAT_CHECKED: 'Cochés',
    STAT_SAVED: 'Enregistrés',
    STAT_PENDING: 'À valider',
    FILTER_VIEW_ARIA: 'Filtrer l’affichage',
    FILTER_ALL: 'Tous',
    FILTER_CHECKED: 'Cochés',
    FILTER_PENDING: 'À enregistrer',
    FILTER_ALL_TYPES: 'Toutes catégories',
    SELECT_ALL_VISIBLE: 'Tout cocher (vue)',
    CLEAR_NEW: 'Annuler les nouveaux',
    RECORDED_BADGE: 'OK',
    PENDING_BADGE: 'Nouveau',
    GLOBAL_NOTE_LABEL: 'Note optionnelle',
    GLOBAL_NOTE_PLACEHOLDER: 'Note pour les actes sans traitement type…',
    SAVE_BUTTON: 'Enregistrer ({n})',
    SAVE_BUTTON_NONE: 'Enregistrer',
    NOTHING_NEW: 'Aucun nouvel acte à enregistrer.',
    SAVED_ONE: 'Soin enregistré.',
    SAVED_MANY: '{n} soins enregistrés.',
    SAVE_ERROR: 'Enregistrement impossible.',
    MANUAL_TITLE: 'Hors catalogue',
    KINDS: {
      care: {
        INTRO: 'Cliquez sur une carte pour cocher le soin réalisé.',
        LOADING: 'Chargement du catalogue soins…',
        EMPTY_CATALOG: 'Catalogue soins vide — configuration par la direction médicale.',
        STAT_TOTAL: 'Soins',
        SAVED_ONE: 'Soin enregistré.',
        SAVED_MANY: '{n} soins enregistrés.'
      },
      injection: {
        INTRO: 'Cliquez sur une carte pour cocher l’injection réalisée.',
        LOADING: 'Chargement du catalogue injections…',
        EMPTY_CATALOG: 'Catalogue injections vide — configuration par la direction médicale.',
        STAT_TOTAL: 'Injections',
        SAVED_ONE: 'Injection enregistrée.',
        SAVED_MANY: '{n} injections enregistrées.',
        NOTHING_NEW: 'Aucune nouvelle injection à enregistrer.'
      },
      family_planning: {
        INTRO: 'Cliquez sur une carte pour cocher l’acte de planning familial réalisé.',
        LOADING: 'Chargement du catalogue planning familial…',
        EMPTY_CATALOG: 'Catalogue planning familial vide — configuration par la direction médicale.',
        STAT_TOTAL: 'Actes',
        SAVED_ONE: 'Acte de planning familial enregistré.',
        SAVED_MANY: '{n} actes de planning familial enregistrés.',
        NOTHING_NEW: 'Aucun nouvel acte de planning familial à enregistrer.'
      }
    }
  },

  QUEUE: {
    BADGE: 'File infirmerie',
    PAGE_TITLE: 'File infirmerie',
    PAGE_SUBTITLE: 'Passages du site sélectionné',
    SEGMENTS_ARIA: 'En cours ou terminés',
    SEGMENT_ACTIVE: 'En cours',
    SEGMENT_DONE: 'Terminés',
    LOADING: 'Chargement de la file…',
    SEARCH_ARIA: 'Rechercher un patient',
    SEARCH_PLACEHOLDER: 'Nom, prénom ou matricule…',
    REFRESH: 'Actualiser',
    REFRESH_ARIA: 'Actualiser la file infirmerie',
    NO_SITE: 'Sélectionnez un site de travail dans la barre supérieure.',
    FILTERS_ARIA: 'Affiner les passages en cours',
    FILTER_ALL: 'Tous',
    LIST_ARIA: 'Liste des passages infirmerie',
    EMPTY: 'Aucun passage pour ce filtre.',
    EMPTY_ACTIVE_TITLE: 'Aucun passage en cours',
    EMPTY_DONE_TITLE: 'Aucun passage terminé',
    EMPTY_DONE: 'Aucun passage clôturé ou transféré pour ce site.',
    EMPTY_ACTIVE_ONLY:
      'Aucun passage en cours — consultez Terminés ou accueillez un adhérent au poste infirmerie.',
    EMPTY_PENDING: 'Aucun passage à traiter — les nouveaux arrivants apparaissent ici.',
    EMPTY_CARE: 'Aucun passage en soins ou avec constantes enregistrées.',
    EMPTY_EXAM: 'Aucun passage avec contenu saisi dans la rubrique Examen.',
    EMPTY_PENDING_TITLE: 'Rien à traiter',
    EMPTY_CARE_TITLE: 'Aucun passage en soins',
    EMPTY_EXAM_TITLE: 'Aucun passage en examen',
    COL_PATIENT: 'Patient',
    COL_STATUS: 'Statut',
    COL_ACTION: 'Ouvrir le passage',
    ACTION_OPEN: 'Ouvrir',
    ACTION_VIEW: 'Consulter'
  }
};
